import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import "../0.styles.css";
import { FormControlLabel, FormGroup, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../Components/AuthContext";
import { addEspaceCharacters, instance } from "../Components/config";
import { DialogAlert } from "../Components/DialogAlert";
import { LoaderBox } from "../Components/LoaderBox";
import { DropDownList } from "../Components/DropDownList";

function CultivarAgregar() {
  const [subproducto, setSubproducto] = React.useState({ Id: "", Nombre: "" });
  const [tipoCultivo, setTipoCultivo] = React.useState({ Id: "", Nombre: "" });
  const [dialog, setDialog] = React.useState({
    title: "",
    text: "",
    redirect: false,
    page: "/Cultivar",
  });
  const [openDialog, setOpenDialog] = React.useState(false);
  const navigate = useNavigate();
  const { user } = useAuth();
  const handleSubmit = (e) => {
    e.preventDefault();
    const info = e.target;
    instance
      .post("/cultivo/cultivar", {
        id: user.id,
        nombre: addEspaceCharacters(info.nombre.value),
        descripcion: addEspaceCharacters(info.descripcion.value),
        tipoCultivo: tipoCultivo.Id,
        subProducto: subproducto.Id
      })
      .then((res) => {
        setDialog({
          title: "Operación exitosa",
          text: "El tipo de cultivo ha sido creado exitosamente.",
          redirect: true,
          page: "/Cultivar",
        });
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
      })
      .finally(setOpenDialog(true));
  };
  return (
    <LoaderBox>
      <Container
        component="main"
        maxWidth="xs"
        className="bordered-box"
        sx={{
          padding: "4px",
          marginTop: 8,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: 4,
            marginBottom: 4,
          }}
        >
          <Typography component="h1" variant="h5">
            Nuevo cultivar
          </Typography>
          <Grid
            container
            component="form"
            sx={{ mt: 1, display: "flex", flexDirection: "column" }}
            onSubmit={handleSubmit}
          >
            <Grid
              item
              sx={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <DropDownList
                required
                title="Subproducto"
                endpoint={"/producto/listAllSemillas"}
                selectedItem={subproducto}
                setSelectedItem={setSubproducto}
              />
            </Grid>
            <Grid
              item
              sx={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <DropDownList
                required
                title="Cultivo"
                endpoint={"/cultivo/tipos/active"}
                selectedItem={tipoCultivo}
                setSelectedItem={setTipoCultivo}
              />
            </Grid>

            <Grid>
              <TextField
                margin="normal"
                required
                fullWidth
                label={"Nombre del cultivar"}
                id="nombre"
                name="nombre"
                autoFocus
                inputProps={{ maxLength: 100 }}
              />
            </Grid>

            <Grid>
              <TextField
                id="descripcion"
                name="descripcion"
                label="Descripción"
                multiline
                required
                fullWidth
                inputProps={{ maxLength: 250 }}
              />
            </Grid>
            <Grid>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
                Agregar
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Container>
      <DialogAlert
        title={dialog.title}
        text={dialog.text}
        open={openDialog}
        setOpen={setOpenDialog}
        redirectOnClose={dialog.redirect}
        page={dialog.page}
      />
    </LoaderBox>
  );
}

export { CultivarAgregar };
